export default {
  columns: {
    title: 'Titlu',
    image: 'Imagine',
    button_url: 'URL buton',
    button_text: 'Text buton',
    description: 'Descriere',
    visible: 'Vizibil',
    actions: 'Acțiuni',
  },
  buttons: {
    create_post: 'Creează postare',
    edit: 'Editează',
    delete: 'Șterge',
    cancel: 'Anulează',
    confirm: 'Confirmă',
  },
  title: 'Postări promovate',
  delete_confirmation: 'Sigur doriți să ștergeți această postare?',
};
